import React, { forwardRef } from 'react'

const ErrorHeaderLogo = forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>(({ height = 56, width = 264, ...props }, ref) => (
  <svg
    ref={ref}
    width={width}
    height={height}
    viewBox="0 0 264 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="132"
      cy="28"
      r="28"
      className="fill-background-surface-secondary"
    />
    <circle
      cx="28"
      cy="28"
      r="28"
      className="fill-background-surface-secondary"
    />
    <path
      d="M132 29.4143L139.293 36.7072L140.707 35.293L133.414 28.0001L140.707 20.7072L139.293 19.293L132 26.5859L124.707 19.293L123.293 20.7072L130.586 28.0001L123.293 35.293L124.707 36.7072L132 29.4143Z"
      fill="#E51C00"
    />
    <circle
      cx="236"
      cy="28"
      r="28"
      className="fill-background-surface-secondary"
    />
    <path
      d="M18 22L28 16L38 22M18 22V34L28 40M18 22L28 28M28 40L38 34V22M28 40V28M38 22L28 28"
      className="stroke-background-inverse"
      strokeWidth="2"
    />
    <path
      className="fill-background-inverse"
      d="M235.042 30.453v-5.192l-.324-.325h-5.183l-.324.325v5.192l.324.325h5.183zM225.324 32.076 225 32.4v3.083l.324.325h3.077l.324-.325V32.4l-.324-.324zM225.324 19.907l-.324.324v3.083l.324.325h3.077l.324-.325V20.23l-.324-.325z"
    />
    <path
      className="fill-background-inverse"
      d="M247.676 24.125h-5.831l-.324-.324v-5.03l-.324-.325h-5.183l-.324-.324v-3.083l-.324-.325h-3.563l-.324.325v3.732l.324.324h3.887l.324.325v5.03l.324.324h5.507l.324.325v5.517l-.324.324h-5.507l-.324.325v5.03l-.324.324h-3.887l-.324.325v3.731l.324.325h3.563l.324-.325v-3.082l.324-.325h5.183l.324-.324v-5.03l.324-.325h5.831l.324-.324V24.45z"
    />
    <line
      x1="61"
      y1="27"
      x2="99"
      y2="27"
      className="stroke-background-inverse"
      strokeOpacity="0.08"
      strokeWidth="2"
      strokeLinecap="round"
      strokeDasharray="4 4"
    />
    <line
      x1="165"
      y1="27"
      x2="203"
      y2="27"
      className="stroke-background-inverse"
      strokeOpacity="0.08"
      strokeWidth="2"
      strokeLinecap="round"
      strokeDasharray="4 4"
    />
  </svg>
))
ErrorHeaderLogo.displayName = 'ErrorHeaderLogo'

export default ErrorHeaderLogo
